import { call, put, takeLatest } from "redux-saga/effects";
import { IBaseResponse } from "../../../interfaces/base";
import {
  fetchUsersStart,
  fetchUsersSuccess,
  fetchUsersFailed,
} from "./users-slice";
import { IFetchUsersAction } from "../../../interfaces/store/users-interfaces";
import { searchUsersApi } from "../../../api/accounts";

function* _fetchUsers({ payload }: IFetchUsersAction) {
  try {
    const { sort, pagination, search } = payload;

    const response: IBaseResponse = yield call(searchUsersApi, {
      sort: sort || { sortBy: "updatedAt", sortOrder: -1 },
      search,
      pagination,
      filter: { role: "client" },
    });

    if (response.error) {
      yield put(fetchUsersFailed(response.error));
    } else {
      yield put(fetchUsersSuccess({ data: response.data }));
    }
  } catch (error: any) {
    yield put(fetchUsersFailed({ message: error.message }));
  }
}

function* usersSaga() {
  yield takeLatest(fetchUsersStart.type, _fetchUsers);
}

export default usersSaga;
